import { origin } from './constant';

const MemberURI = {
  membersURI: `${origin}/members`,
  modifyPasswordURI: `${origin}/members/modifyPassword`,
  getMemberURI: `${origin}/members/query`,
};

export default MemberURI;
